import type { App } from 'vue';

import { t } from '@/config/i18n';

export const i18nPlugin = {
  install: (app: App) => {
    app.config.globalProperties.$t = t;
    app.provide('t', t);
  }
};
